<template>
	<div  v-loading="loading" id="mysends"> 
		<Header></Header>
		<TwiceTitle></TwiceTitle>
		<div class="container">
			<div　class='none'  v-if="shop.length == 0">
				<img style="width:200px;height:250px" src="/static/image/null.svg" alt="">
				<div>非常抱歉！没有找到符合条件的商品!</div>
				<div style="font-size:14px;">您可以尝试：修改筛选条件或输入新的关键字重新查找</div>
			</div>
			<div v-for="item in shop" v-bind:key="item.id" class="shop-details">
				<div>
					<router-link style="text-decoration:none;color:#444444" :to="{path:'detail/?id='+item.id }">
					<img style="width:193px;height:195px;" v-lazy="lazyImg(item.cover_img)" :onerror="defaultImg">
					</router-link>
				</div>
				<div class="right-details">
				<router-link style="text-decoration:none;color:#444444" :to="{path:'detail/?id='+item.id }">
					<div class="title">{{item.title}}</div>
				</router-link>	
					<div class="star">
						<div>
							<img src="@/assets/wjx.png" alt="">
							<img src="@/assets/wjx.png" alt="">
							<img src="@/assets/wjx.png" alt="">
							<img src="@/assets/wjx.png" alt="">
							<img src="@/assets/wjxk.png" alt="">
						</div>
						<div class="condition">{{item.purity_name}}</div>
						<div class="address">所在地{{item.province}}省：{{item.city}}市</div>
					</div>
					<div class="shop-describe">
						{{item.description}}
					</div>
					<div class="foot-box">
						<div class="money"><span style="font-size:14px">￥</span>{{item.sale_price}}</div>
						<div class="see-num">
							<!--<div class="pic"><img :src="item.bbs.user_avatar" alt="">  {{item.bbs.username}}</div>-->
							<div class="num"><img src="@/assets/liulan.png" alt=""> {{item.goods_hits}} 次</div>
							<div class="num"><img src="@/assets/msg.png" alt=""> {{item.comment_count}} 条</div>
							<div class="num"><img src="@/assets/sj.png" alt="">发布于{{item.create_time|time}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
			<div v-if="shop.length != 0" class="pagination">
				<el-pagination
						background
						@current-change="changePage"
						:current-page="page"
						:page-size="12"
						layout="prev, pager, next"
						:total="total">
				</el-pagination>
				<span>共{{pagenum.last_page}}页</span>
			</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Foot from '@/components/common/Foot'
	import Header from '@/components/twicehands/Header'
	import TwiceTitle from '@/components/twicehands/TwiceTitle'
	import Mixin from '@/common/js/mixin'
	export default {
		mixins: [Mixin],
		name: "twicehands-mysends",
		components:{
			Foot,
			Header,
			TwiceTitle
		},
		data (){
			return {
				shop:[],
				defaultImg: 'this.src="' + require('../../assets/Bitmap.png') + '"',
				loading:true, //加载,
				total:0,
				current_page:0,
				page:1,
				pagenum:[]
			}
		},
		created () {
			this.getShopList()
		},
		methods:{
			getShopList: function () {
				this.$get('/apis/idle/idle', {
					params: {
						uid:window.uId,
						page:this.page,
						idle_type:1
					}
				}).then((res)=>{
					if(res){
						this.shop = res.data.data
						this.loading = false;
					// 分页参数
						this.pagenum=res.data
						this.total = res.data.total
						this.page = res.data.current_page
					}
				})
			},
			changePage(currentPage){
				this.page = currentPage;
				this.getShopList();
				document.body.scrollTop = document.documentElement.scrollTop = 0
			},
		}
	}
</script>
<style >
	#mysends .container{
		box-sizing: border-box;
		width: 1200px;
		margin: auto;
	}
	#mysends .class-box{
		background:  #EDEDED;
		height: 158px;
	}
	#mysends .class-list{
		display: flex;
	}
	#mysends .name{
		margin-top: 25px;
		margin-left: 13px;
	}
	.el-submenu .el-menu{
		z-index: 1;
	}
	.el-pagination.is-background .el-pager li.number:hover{
		color:#f9be04;
	}

	.el-pagination.is-background .el-pager li.active:hover{
		color:#fff;
	}
	.el-pagination.is-background .el-pager li:not(.disabled).active{
		background: rgba(0,0,0,0.00);
		border: 1px solid #F9BE04;
	}
	.el-pagination.is-background .el-pager li:not(.disabled).active{
		background: #F9BE04;
	}
	.el-radio__input.is-checked+.el-radio__label{
		color:#F9BE04
	}
	.el-radio__input.is-checked .el-radio__inner{
		background: #F9BE04;
		border-color:#F9BE04
	}
	.el-upload--picture-card{
		margin-left: 5px;
	}
	.el-input{
		margin-left: 5px;
	}
	.el-pagination.is-background .el-pager li{
		border: 1px solid #D5D5D5;
		color: #D5D5D5;
	}
	#mysends .select{
		border: 1px solid #D3D3D2;
		border-radius: 8px;
		margin-top: 25px;
		padding: 0 12px;
		font-size: 12px;
		color: #D3D3D2;
		margin-left: 20px;
	}
	#mysends .first-select{
		border: 1px solid #F9BE04;
		border-radius: 8px;
		color: #F9BE04;
		margin-top: 25px;
		padding: 0 12px;
		font-size: 12px;
		margin-left: 20px;

	}
	#mysends .search-money{
		margin-top: 25px;
		margin-left: 20px;
	}
	#mysends .search-money input{
		border: 1px solid #d3d3d2;
		background: #EDEDED;
		width: 75px;
		height: 21px;
		font-size: 12px;
		text-align: center;
		border-radius: 2px;
	}
	#mysends .search-money span{
		color: #d3d3d2
	}
	#mysends .sort-box{
		display: flex;
		justify-content: space-between;
		border: 1px solid #f7f7f7;
		height: 42px;
		line-height: 42px;
		margin-top: 25px;
		margin-bottom:25px;
	}
	#mysends .sort-name{
		display: flex;
	}
	#mysends .sort-all{
		width: 135px;
		font-size: 12px;
		color: #979797;
		margin-left: 43px;
	}
	#mysends .sort-all img{
		width: 6px;
		height: 6px;
		padding-left: 5px;
	}
	#mysends .equipment{
		font-size: 12px;
		color: #979797;
		margin-right: 22px;
	}
	#mysends .first-sort{
		color: #F9BE04;
	}
	#mysends .vertical{
		background: #CECECE;
		width: 1px;
		height: 26px;
		margin-top: 8px;
	}
	#mysends .shop-details{
		display: flex;
		border:1px solid #f7f7f7;
		box-sizing: border-box;
		padding: 20px;
		margin-top: -1px;
	}
	#mysends .right-details{
		margin-left: 20px;
	}
	#mysends .right-details .title{
		font-size: 20px;
		color: #444444;
	}
	#mysends .star{
		display: flex;
		line-height: 17px;
		margin-top: 12px;
	}
	#mysends .star img{
		width: 13px;
		height: 13px;
	}
	#mysends .condition{
		font-size: 12px;
		color: #F9BE04;
		margin-left: 10px;
	}
	#mysends .address{
		font-size: 12px;
		color: #737373;
		margin-left: 15px;
	}
	#mysends .shop-describe{
		font-size: 12px;
		color: #2E2E2E;
		margin-top: 11px;
		height: 80px;
	}
	#mysends .money{
		font-size: 30px;
		color: #F9BE04;
	}
	.none{
		text-align: center;
		color: #555;
		font-size: 18px;
		margin: auto;
		min-height: 400px;
	}
	#mysends .foot-box{
		display: flex;
		justify-content: space-between;
		margin-top: 15px;
	}
	#mysends .see-num{
		display: flex
	}
	#mysends .pic{
		display: flex;
		align-items: center;
		font-size: 18px;
		color: #656565;
	}
	#mysends .pic img{
		width: 32px;
		height: 32px;
		border-radius: 16px;
	}
	#mysends .num{
		font-size: 12px;
		color: #656565;
		display: flex;
		align-items: center;
		margin-left:21px;
	}
	#mysends .num img{
		padding-right: 5px;
	}
</style>


// WEBPACK FOOTER //
// src/components/twicehands/Mysends.vue